import usStateCodes from 'us-state-codes';

/**
 * Filters table data based on user input
 *
 * @param {array} data - The array of row data to be filtered.
 * @param {string} activePenalty - The displayed penalty type.
 * @param {string} activeSearch - Search string, if any.
 * @param {string} activeState - State to display.
 * @param {string} activeYear - Year to display.
 * @param {array}  years - Array of years..
 * @returns {array} tableData - The filter array of table rows.
 */
export default function getFilteredData(data, activeSearch, activeState) {
  // Make a deep copy of the rows array to avoid side effects.
  const tableData = data.map((row) => ({ ...row }));

  // Set up regex for text search if applicable
  const escapedInput = activeSearch ?
    activeSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : null;
  const regex = new RegExp(escapedInput, 'i');

  return tableData.filter((hospital) => {
    // Filter for state
    const matchesSelectedState = activeState === hospital.state;
    // Filter for search string
    const matchesSearchString = (regex.test(hospital.name) ||
        regex.test(hospital.city) ||
        regex.test(hospital.county) ||
        regex.test(hospital.state) ||
        regex.test(
          usStateCodes.getStateNameByStateCode(hospital.state)
          )
        );
    return (
      (activeState ? matchesSelectedState : true) &&
      (activeSearch ? matchesSearchString : true)
    );
  });
}
